export default __webpack_public_path__ + "static/media/logo_pnsv_horizontal.b1aae869.png";